import { AxiosResponse } from 'axios';
import { SET_MEMBERS, SET_MEMBER, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_MEMBER_ISLOADING,
  DELETE_MEMBER,
  EDIT_MEMBER,
  GET_MEMBERS,
  REGISTER_MEMBER,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Member from '@/services/member';
import { Module } from 'vuex';
import { EditMember, RegisterMember, GetMember } from '@/dtos/member.dto';

const member: Module<any, {}> = {
  state: {
    member: {
      data: null,
      isLoading: false,
    },
    members: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    member: (state: { member: any }) => state.member,
    members: (state: { members: any }) => state.members,
  },
  mutations: {
    [SET_MEMBER]: (
      state: { member: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.member.data = payload.data) : null,
        (state.member.isLoading = payload.isLoading);
    },
    [SET_MEMBERS]: (
      state: { members: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.members.data = payload.data) : null,
        (state.members.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_MEMBER]: async ({ commit }: any, payload: any) => {
      commit(SET_MEMBER, { data: null, isLoading: true });

      const result: AxiosResponse = await Member.registerMember(
        payload as RegisterMember
      );

      if (result) {
        if (result.data.status) {
          commit(SET_MEMBER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MEMBER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MEMBER, { isLoading: false });
        return false;
      }
    },
    [GET_MEMBERS]: async ({ commit }: any, payload: any) => {
      commit(SET_MEMBERS, { data: null, isLoading: true });

      const result: AxiosResponse = await Member.getMembers(
        payload as GetMember
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MEMBERS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MEMBERS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MEMBERS, { isLoading: false });
        return false;
      }
    },
    [EDIT_MEMBER]: async ({ commit }: any, payload: any) => {
      commit(SET_MEMBER, { data: null, isLoading: true });

      const result: AxiosResponse = await Member.editMember(
        payload as EditMember
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MEMBER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MEMBER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MEMBER, { isLoading: false });
        return false;
      }
    },
    [DELETE_MEMBER]: async ({ commit }: any, payload: string) => {
      commit(SET_MEMBER, { data: null, isLoading: true });

      const result: AxiosResponse = await Member.deleteMember(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MEMBER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MEMBER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MEMBER, { isLoading: false });
        return false;
      }
    },
    [CLEAR_MEMBER_ISLOADING]: ({ commit }) => {
      commit(SET_MEMBER, { isLoading: false });
      commit(SET_MEMBERS, { isLoading: false });
    },
  },
};

export default member;
